var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticStyle:{"font-weight":"600"},on:{"click":_vm.toggleTheme}},[(_vm.getTheme === 'light')?_c('i',{staticClass:"fa-solid fa-moon"}):_c('i',{staticClass:"fa-solid fa-sun"})])
}
var staticRenderFns = []

export { render, staticRenderFns }